import React, { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// -------------------------------------------------------------
// Events / enquiries
// -------------------------------------------------------------
function EventsTab() {
  const [kind, setKind] = useState("");
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    const q = kind ? `?kind=${kind}&limit=100` : "?limit=100";
    axios
      .get(`${API}/admin/events${q}`)
      .then((r) => setList(r.data))
      .finally(() => setLoading(false));
  };
  useEffect(load, [kind]);

  const kindLabels = {
    "": "All events",
    register: "Registrations",
    login: "Logins",
    design_view: "Design Views",
    wishlist_add: "Wishlist Adds",
    wishlist_remove: "Wishlist Removes",
    whatsapp_click: "WhatsApp Enquiries",
  };

  return (
    <div>
      <h1 className="admin-h1">Enquiry & Activity Log</h1>
      <p className="admin-sub">Real-time log of what customers are doing on the site.</p>
      <div className="admin-filter-row">
        {Object.entries(kindLabels).map(([k, label]) => (
          <button
            key={k}
            type="button"
            className={kind === k ? "on" : ""}
            onClick={() => setKind(k)}
          >
            {label}
          </button>
        ))}
      </div>
      <div className="admin-card">
        {loading ? (
          <p className="admin-muted">Loading…</p>
        ) : list.length === 0 ? (
          <p className="admin-muted">No events yet in this filter.</p>
        ) : (
          <table className="admin-table">
            <thead>
              <tr>
                <th>When</th>
                <th>Who</th>
                <th>What</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              {list.map((e) => {
                const p = e.payload || {};
                let details = "";
                if (p.design) details = p.design.name || "";
                else if (p.designs) details = `${p.designs.length} designs`;
                if (p.source) details += (details ? " · " : "") + p.source;
                return (
                  <tr key={e.id}>
                    <td>{new Date(e.created_at).toLocaleString()}</td>
                    <td>
                      <div className="admin-who">
                        <strong>{e.user_name || "—"}</strong>
                        <span>{e.user_email || "—"}</span>
                      </div>
                    </td>
                    <td>
                      <span className={`admin-kind admin-kind-${e.kind}`}>{e.kind}</span>
                    </td>
                    <td>{details || "—"}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default EventsTab;
